import {ref} from "vue";

export const useLoading = (initialValue) => {
    const isLoading = ref(initialValue);

    return {
        isLoading,
        startLoading: () => isLoading.value = true,
        stopLoading: () => isLoading.value = false
    };
}